import { render, staticRenderFns } from "./failorder.vue?vue&type=template&id=0216fe56&scoped=true&"
import script from "./failorder.vue?vue&type=script&lang=js&"
export * from "./failorder.vue?vue&type=script&lang=js&"
import style0 from "./failorder.vue?vue&type=style&index=0&id=0216fe56&lang=less&scoped=true&"
import style1 from "./failorder.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0216fe56",
  null
  
)

export default component.exports